/**
 * Ключ аудио-модели для массовой загрузки звука открытия двери.
 * RV3438 (Rubetek 38), RV3434 (Rubetek 34), DKS15134 (Beward).
 */

export const OPEN_DOOR_SOUND_MODEL_KEYS = ['RV3438', 'RV3434', 'DKS15134'];

const MODEL_LABELS = {
  RV3438: 'Rubetek RV-3438',
  RV3434: 'Rubetek RV-3434',
  DKS15134: 'Beward',
};

export function getOpenDoorSoundModelKey (model) {
  if (!model) return null;

  const normalized = String(model).replace(/-/g, '').replace(/\s+/g, '').toUpperCase();

  if (['DKS15134', 'DKS20211', 'DKS20210', 'DKS1512'].includes(normalized)) {
    return 'DKS15134';
  }

  if (normalized === 'RV3438') {
    return 'RV3438';
  }

  if (normalized === 'RV3434') {
    return 'RV3434';
  }

  return null;
}

export function getOpenDoorSoundModelLabel (key) {
  return MODEL_LABELS[key] || key;
}

/** Группы выбранных домофонов по ключу аудио-модели. */
export function groupSelectedBySoundModel (selected = []) {
  const groups = {};

  selected.forEach((item) => {
    const key = getOpenDoorSoundModelKey(item.model);
    if (!key) return;
    if (!groups[key]) {
      groups[key] = {
        key,
        label: getOpenDoorSoundModelLabel(key),
        count: 0,
        ids: [],
      };
    }
    groups[key].count += 1;
    groups[key].ids.push(item.id);
  });

  return OPEN_DOOR_SOUND_MODEL_KEYS
    .filter((key) => groups[key])
    .map((key) => groups[key]);
}
